module.exports = "<li class=\"applied-filter\"><strong>{{getLabel()}} </strong><strong><i class=\"icon-cross\" ng-click=\"remove()\"></i></strong></li>\n";